export const UkIcon = () => {
return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_8524_2523" maskUnits="userSpaceOnUse" x="0" y="4" width="24" height="16">
    <rect y="4" width="24" height="16" rx="2" fill="#FFF"/>
    </mask>
    <g mask="url(#mask0_8524_2523)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12H24V4H0V12Z" fill="#156DD1"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 20H24V12H0V20Z" fill="#FFD948"/>
    </g>
    </svg>
  )
}
